/* Skunkworks theme — progressive enhancement only.
   Navigation, cart and checkout all work without JavaScript. */
(function () {
  'use strict';

  var root = document.documentElement;

  // Mobile menu
  var button = document.querySelector('[data-menu-button]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (button && menu) {
    var setOpen = function (open) {
      button.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
    };
    setOpen(false);
    button.addEventListener('click', function () {
      setOpen(button.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        button.focus();
      }
    });
    window.matchMedia('(min-width: 821px)').addEventListener('change', function (e) {
      if (e.matches) setOpen(false);
    });
  }

  // Light / dark toggle (only present when enabled in theme settings)
  var toggles = document.querySelectorAll('[data-theme-choice]');
  var KEY = 'skunkworks-theme';
  var apply = function (choice) {
    if (choice === 'light' || choice === 'dark') {
      root.setAttribute('data-theme', choice);
    } else {
      root.removeAttribute('data-theme');
    }
    toggles.forEach(function (el) {
      el.setAttribute('aria-pressed', String(el.getAttribute('data-theme-choice') === (choice || 'system')));
    });
  };
  if (toggles.length) {
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) { /* storage unavailable */ }
    apply(saved || 'system');
    toggles.forEach(function (el) {
      el.addEventListener('click', function () {
        var choice = el.getAttribute('data-theme-choice');
        try {
          if (choice === 'system') localStorage.removeItem(KEY);
          else localStorage.setItem(KEY, choice);
        } catch (e) { /* ignore */ }
        apply(choice);
      });
    });
  }

  // Auto-submit sort select on collection pages
  var sort = document.querySelector('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
